import type {ReactElement, ReactNode} from 'react';
import PrimaryButton from '@components/Button/PrimaryButton/PrimaryButton';
import {sendVerificationCode} from '@api/user';
import GenericErrorScreen from '@components/Error/GenericErrorScreen';
import useMutationWithAuth from '@hooks/useMutationWithAuth';
import styles from './index.module.scss';
import {useSnackbar} from 'notistack';
import {msg, Trans} from '@lingui/macro';
import {useLingui} from '@lingui/react';

interface Props {
    children: ReactNode;
}

export default function ResendCode(props: Props): ReactElement<Props> {
    const {_} = useLingui();
    const {enqueueSnackbar} = useSnackbar();
    const sendCodeMutation = useMutationWithAuth({
        mutationKey: ['sendVerificationCode'],
        mutationFn: sendVerificationCode,
    });

    function handleClick() {
        void sendCodeMutation
            .mutateAsync()
            .then(() => enqueueSnackbar({variant: 'info', message: _(msg`Email sent`)}));
    }

    if (sendCodeMutation.isError) {
        return <GenericErrorScreen />;
    }

    return (
        <>
            {props.children}
            <PrimaryButton
                className={styles.button}
                onClick={handleClick}
                disabled={sendCodeMutation.isLoading}
            >
                <Trans>Send new code</Trans>
            </PrimaryButton>
        </>
    );
}

ResendCode.defaultProps = {
    isLoading: false,
};
